import React, { createContext, useContext, useEffect, useState } from 'react';
import { errorBus } from '../api/errorBus';

const ErrorContext = createContext(null);

export function ErrorProvider({ children }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    return errorBus.subscribe(setError);
  }, []);

  // const showError = (err) => setError(err);
  const clearError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ error, clearError }}>
      {children}
    </ErrorContext.Provider>
  );
}

export function useError() {
  return useContext(ErrorContext);
}
